import React from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { Dotdotdot } from 'components';
import * as styles from './ContentCard.scss';
import Avatar from 'material-ui/Avatar';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import RaisedButton from 'material-ui/RaisedButton'; //! _.isEmpty(d.metadata)

function ContentCard(props) {
  var handlePostCardClick = props.handlePostCardClick,
      image = props.image,
      message = props.message,
      title = props.title,
      dominantImageColor = props.dominantImageColor,
      metadata = props.metadata,
      linkUrl = props.linkUrl;
  var isRSSIdea = !!metadata && !_.isEmpty(metadata) && metadata.hasOwnProperty('rssSourceName');
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrap,
    style: isRSSIdea ? {
      border: '1px solid gold'
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handlePostCardClick
  }, isRSSIdea && /*#__PURE__*/React.createElement("div", {
    className: styles.ribbon
  }, /*#__PURE__*/React.createElement("span", null, "News")), image && /*#__PURE__*/React.createElement("img", {
    className: styles.image,
    src: image,
    style: dominantImageColor ? {
      backgroundColor: dominantImageColor
    } : {}
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrap
  }, !!linkUrl && title && /*#__PURE__*/React.createElement(Dotdotdot, {
    clamp: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, title)), message && /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, /*#__PURE__*/React.createElement(Dotdotdot, {
    clamp: 3
  }, message)), isRSSIdea && /*#__PURE__*/React.createElement("div", {
    className: styles.source
  }, "From: ", metadata.rssSourceName))), isRSSIdea && !!linkUrl && /*#__PURE__*/React.createElement("a", {
    href: linkUrl,
    rel: "noopener",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(RaisedButton, {
    fullWidth: true,
    primary: true,
    label: "View Article"
  })));
}

ContentCard.defaultProps = {
  handlePostCardClick: function handlePostCardClick() {
    console.log('no handler for handlePostCardClick() in ContentCard');
  },
  image: null,
  message: '',
  title: ''
};
export default ContentCard;